module.exports = __webpack_public_path__ + "media/images/buttons/button-social-instagram-1541c0ae25ecbbfea4c978ae5d531418.svg";